import stampit from 'stampit';
import { NotImplementedError } from "../../util/errors/index.js";
const ResolveStrategy = stampit({
  props: {
    name: null
  },
  methods: {
    canResolve() {
      return false;
    },
    async resolve() {
      throw new NotImplementedError();
    }
  }
});
export default ResolveStrategy;